<template>
    <div class="newDetail_home">
        <div class="nd1">
            <div class="nd1_time">
                <p>{{ newsData.create_time }}</p>
                <p class="slogan">GO FAR WITH RoSSo</p>
            </div>
            <div class="nd1_big_title">{{ newsData.title }}</div>
            <div v-html="newsData.article_content" class="nd1_html_box"></div>
        </div>
        <div class="nd2">
            <div class="pre" @click="jopPreNew(newsData.preInfo.id)">&lt; 上一篇：{{ newsData.preInfo | preFilter }}</div>
            <div class="next" @click="jopNextNew(newsData.nextInfo.id)">下一篇：{{ newsData.nextInfo | nextFilter
            }}<span>></span></div>
        </div>
        <div class="nd3">

            <!-- <img src="../img/newlast3.jpg" alt=""> -->
            <!-- <img src="../img/newlast1.gif" alt="">
            <img src="../img/newlast2.jpg" alt=""> -->
            <img src="../img/newD3.png" alt="">
        </div>
    </div>
</template>
<script>
import axios from "axios"
import "@/assets/css/newDetail.css"
export default {
    data() {
        return {
            newsData: [],
        }
    },
    filters: {
        preFilter(val) {
            if (val) {
                return val == "" ? "无" : val.title
            } else {
                return "无"
            }
        },
        nextFilter(val) {
            if (val) {

                return val == "" ? "无" : val.title
            }
        }
    },

    created() {
        this.getNewsId(this.$route.params.id.split(".")[0])
    },
    methods: {
        jopPreNew(val) {
            if (val) {
                this.$router.push(`/news/${val}.html`)
                this.getNewsId(val)
            }
        },
        jopNextNew(val) {
            if (val) {
                this.$router.push(`/news/${val}.html`)
                this.getNewsId(val)
            }
        },
        getNewsId(val) {
            axios.get(`https://public.rossoarts.com/api/v1/getArtsNew?id=${val}`).then((data) => {
                // console.log(data.data.data);
                this.newsData = data.data.data
                this.$nextTick(() => {
                    // var htmlImg = document.getElementsByClassName("rich_pages wxw-img")
                    var htmlImg = document.getElementsByClassName("nd1_html_box")[0].getElementsByTagName("img")
                    //    console.log(htmlImg[0].src);
                    for (var i = 0; i < htmlImg.length; i++) {
                        // console.log(htmlImg[i].src);
                        htmlImg[i].src = "https://public.rossoarts.com/static/upload/image/" + htmlImg[i].src.split("/")[htmlImg[i].src.split("/").length - 2] + '/' + htmlImg[i].src.split("/")[htmlImg[i].src.split("/").length - 1]
                        // console.log(htmlImg[i].src);
                    }

                })
            })
        },
    }
}
</script>